import moment from 'moment';
import { checkCircleSVG, errorCircleSVG } from '../../shared/helpers/icons';

export const buildDevices = (devices) => devices.map((device => buildDevice(device)))

export const buildDevice = (device) => ({
    ...device,
    admission_date: moment(device.admission_date).format("DD-MM-YYYY"),
    admission_CompleteDate: device.admission_date,
    enabledIcon: device.enabled ? checkCircleSVG : errorCircleSVG,
    imei: device.imei.toString().toUpperCase(),
    model_name: device.model_name ? device.model_name.toString().toUpperCase() : ""
});